import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Binace() {
  const processes_feture = {
    dots: false,
    speed: 500,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 1500,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 1500,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1500,
        },
      },
    ],
  };
  const revenue_slide = {
    arrows: true,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <div className="newpage   blog_page binace binance_anast binance_rish crypto_listing">
      <header className="newpage">
        {/* <Header /> */}
        <NewHead />

        <Helmet>
          <title>Crypto Listing Agency</title>
          <link
            rel="canonical"
            href="https://www.beleaftechnologies.com/crypto-listing-agency"
          />
          <meta name="title" content="  Crypto Listing Agency" />
          <meta
            name="description"
            content=" We specialize in getting your digital assets listed on top-tier exchanges, enhancing accessibility for investors and users. Our expert team ensures a smooth listing process, providing your project the exposure it deserves.            "
          />
        </Helmet>
      </header>

      <main className="binanceclone_main_ik">
        <section className="binanceclone_bannersec_ik d-flex align-items-center">
          <div className="bg_img_listing"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="binanceclone_bannersec_content_ik d-flex flex-column">
                  <h1 className="mb-0">
                    Crypto Listing <span>Agency</span>
                  </h1>
                  <p className="binanceclone_p_ik">
                    Beleaf Technologies is your gateway to get into the dynamic
                    world of cryptocurrencies. Our expert team specializes in
                    all types of token listing services, ensuring your digital
                    assets get the recognition they deserve. List your project
                    now and attract more investors and traders.
                  </p>
                  <Button
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Contact Us"
                    className="binanceclone_button_ik"
                  >
                    Lets Discuss
                  </Button>
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="binanceclone_bannersec_image_ik">
                  <img
                    src={require("../../image/binancecloneik/bannerimg.webp")}
                    className=""
                    alt="Binance
Clone Script Development"
                  />
                  <img
                    src={require("../../image/binancecloneik/bannerimg_boxes.webp")}
                    className="bannerimg_boxes"
                    alt="Binance
Clone Script Development"
                  />
                </div>
              </div> */}
            </div>
          </div>
        </section>
        <section className="binanceclone_whatissec_ik pos-rel ">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                {/* <div className="binanceclone_whatissec_image_ik">
                  <img
                    src={require("../../image/binancecloneik/whatisimg.webp")}
                    className=""
                    alt="Binance
Clone Script Development"
                  />
                  <img
                    src={require("../../image/binancecloneik/whatisimg_boxes.webp")}
                    className="whatisimg_boxes"
                    alt="Binance
Clone Script Development"
                  />
                </div> */}
                <div className="binanceclone_whatissec_content_ik d-flex flex-column">
                  <h2 className="mb-0 binanceclone_h2_ik">
                    What Is
                    <br />
                    Crypto
                    <span className="binanceclone_colorspan_ik">
                      {" "}
                      Listing?{" "}
                    </span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center">
                <div className="binanceclone_whatissec_content_ik d-flex flex-column">
                  <p className="binanceclone_p_ik">
                    A crypto listing is when a digital currency, like Bitcoin or
                    Ethereum, gets officially added to a trading platform or
                    exchange. It allows people to buy, sell, and trade these
                    cryptocurrencies easily. Listing often increases a crypto's
                    visibility and can affect its value.
                  </p>
                  <a href="https://wa.me/7904323274" className="">
                    <button className="binanceclone_button_ik">
                      Talk To Our Experts
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="shabe_left">
            <img
              src={require("../../image/cryptolisting/s_shape2.webp")}
              className="bannerimg_boxes"
              alt="Crypto Listing Agency"
            />
          </div>
        </section>
        <section className="binanceclone_Featuresec_ik pos-rel">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="binanceclone_Featuresec_title_ik ">
                  <h2 className="binanceclone_h2_ik text-center">
                    Token Listings <br />
                    <span className="binanceclone_colorspan_ik">
                      We Specialize In
                    </span>{" "}
                  </h2>
                </div>
              </div>
            </div>
            <div className="binanceclone_Featuresec_cardarea_ik mt-5">
              <div className="row">
                <div className="col-lg-6 col-sm-6 d-flex">
                  <div className="binanceclone_Featuresec_card_ik d-flex flex-column">
                    <div className="coin_image_crypto">
                      <img
                        src={require("../../image/cryptolisting/coinmarket.webp")}
                        className="whatisimg_boxes"
                        alt="Crypto Listing Agency"
                      />
                    </div>
                    <h3 className="binanceclone_h3_ik mb-0">
                      CoinMarketCap Listing
                    </h3>
                    <p className="binanceclone_card_p_ik mb-0">
                      CoinMarketCap Listing is like getting a golden ticket for
                      your cryptocurrency. It means your digital coin is
                      officially recognized and displayed on CoinMarketCap, a
                      popular platform that tracks and ranks cryptocurrencies.
                      This listing boosts your coin's visibility, making it
                      easier for people to find and trade. It's like being in
                      the VIP section of the crypto world, where investors and
                      enthusiasts can easily discover and trust your coin's
                      information, contributing to its credibility and success.
                      Get your project easily listed on coinmarketcap with
                      beleaf.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 d-flex">
                  <div className="binanceclone_Featuresec_card_ik d-flex flex-column">
                    <div className="coin_image_crypto">
                      <img
                        src={require("../../image/cryptolisting/coinko.webp")}
                        className="whatisimg_boxes"
                        alt="Crypto Listing Agency"
                      />
                    </div>
                    <h3 className="binanceclone_h3_ik mb-0">
                      CoinGecko Listing
                    </h3>
                    <p className="binanceclone_card_p_ik mb-0">
                      Secure your place in the crypto ecosystem by getting
                      listed on CoinGecko, a trusted platform for tracking
                      cryptocurrency data. CoinGecko is a website that tracks
                      and provides information about various cryptocurrencies.
                      When a cryptocurrency is listed on CoinGecko, it means
                      that it is officially recognized and has a dedicated page
                      displaying its key details such as price, market cap,
                      trading volume, and more. This listing helps users and
                      investors easily access and analyze information about the
                      specific cryptocurrency, contributing to its visibility in
                      the broader crypto market.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="shabe_right">
            <img
              src={require("../../image/cryptolisting/s_shape1.webp")}
              className="bannerimg_boxes"
              alt="Crypto Listing Agency"
            />
          </div>
        </section>
        <section className="binanceclone_significsec_ik pos-rel pb-0">
          <div className="container contet-top">
            <div className="row mb-5">
              <div className="col-lg-12">
                <div className="binanceclone_significsec_title_ik text-center">
                  <h2 className="binanceclone_h2_ik mb-2">
                    Benefits of Crypto
                    <br />
                    <span className="binanceclone_colorspan_ik">
                      {" "}
                      Listing
                    </span>{" "}
                  </h2>
                </div>
              </div>
            </div>
            <div className="binanceclone_significsec_cardarea_ik mt-5">
              <div className="row">
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="binanceclone_significsec_card  align-items-start d-flex w-100">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <img
                          src={require("../../image/cryptolisting/shared-vision.webp")}
                          className=""
                          alt="Crypto Listing Agency"
                        />
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        Enhanced Visibility
                      </h3>
                    </div>
                    <hr />
                    <div className="binanceclone_significsec_card_ik d-flex flex-column align-itms-center">
                      <p className="binanceclone_card_p_ik mb-0 w-100">
                        {" "}
                        Achieve broader exposure by being listed on popular
                        cryptocurrency tracking platforms, driving potential
                        investors and users to your project.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="binanceclone_significsec_card  align-items-start d-flex w-100">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <img
                          src={require("../../image/cryptolisting/reliability.webp")}
                          className=""
                          alt="Crypto Listing Agency"
                        />
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        Credibility Boost
                      </h3>
                    </div>
                    <hr />
                    <div className="binanceclone_significsec_card_ik d-flex flex-column align-itms-center">
                      <p className="binanceclone_card_p_ik mb-0 w-100">
                        Crypto listing adds a layer of authenticity to your
                        project, enhancing confidence in the minds of potential
                        investors and users.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="binanceclone_significsec_card  align-items-start d-flex w-100">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <img
                          src={require("../../image/cryptolisting/market-analysis.webp")}
                          className=""
                          alt="Crypto Listing Agency"
                        />
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">Market Access</h3>
                    </div>
                    <hr />
                    <div className="binanceclone_significsec_card_ik d-flex flex-column align-itms-center">
                      <p className="binanceclone_card_p_ik mb-0 w-100">
                        Improve liquidity by gaining access to a wider audience
                        of traders and investors who frequent major
                        cryptocurrency platforms.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="binanceclone_significsec_card  align-items-start d-flex w-100">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <img
                          src={require("../../image/cryptolisting/pricing.webp")}
                          className=""
                          alt="Crypto Listing Agency"
                        />
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        Price Discovery
                      </h3>
                    </div>
                    <hr />
                    <div className="binanceclone_significsec_card_ik d-flex flex-column align-itms-center">
                      <p className="binanceclone_card_p_ik mb-0 w-100">
                        Listing on platforms like CoinMarketCap allows users to
                        easily discover your token's current value and market
                        performance.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="binanceclone_significsec_card  align-items-start d-flex w-100">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <img
                          src={require("../../image/cryptolisting/network.webp")}
                          className=""
                          alt="Crypto Listing Agency"
                        />
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        Community Growth
                      </h3>
                    </div>
                    <hr />
                    <div className="binanceclone_significsec_card_ik d-flex flex-column align-itms-center">
                      <p className="binanceclone_card_p_ik mb-0 w-100">
                        A listed token attracts attention, enabling community
                        growth and engagement, essential for the long-term
                        success of any project.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="binanceclone_significsec_card  align-items-start d-flex w-100">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <img
                          src={require("../../image/cryptolisting/competitive.webp")}
                          className=""
                          alt="Crypto Listing Agency"
                        />
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        Competitive Edge
                      </h3>
                    </div>
                    <hr />
                    <div className="binanceclone_significsec_card_ik d-flex flex-column align-itms-center">
                      <p className="binanceclone_card_p_ik mb-0 w-100">
                        Stand out among competitors by showcasing your project
                        on reputable cryptocurrency tracking websites,
                        reinforcing your project's legitimacy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="token-info__shape">
            <div className="shape shape--1">
              <img
                src={require("../../image/cryptolisting/ti_shape.webp")}
                className="bannerimg_boxes"
                alt="Crypto Listing Agency"
              />
            </div>
            <div className="shape shape--2">
              <img
                src={require("../../image/cryptolisting/ti_shape2.webp")}
                className="bannerimg_boxes"
                alt="Crypto Listing Agency"
              />
            </div>
          </div>
        </section>
        <section className="binanceclone_significsec_ik pos-rel">
          <div className="container contet-top">
            <div className="row mb-5">
              <div className="col-lg-12">
                <div className="binanceclone_significsec_title_ik text-center">
                  <h2 className="binanceclone_h2_ik mb-2">
                    Our
                    <br />
                    <span className="binanceclone_colorspan_ik">
                      {" "}
                      Expertise
                    </span>{" "}
                  </h2>
                </div>
              </div>
            </div>
            <div className="binanceclone_significsec_cardarea_ik mt-5 experice_section">
              <div className="row justify-content-center">
                <div className="col-lg-2 col-sm-6">
                  <div className="binanceclone_significsec_card  align-items-start d-flex">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <span>200+</span>
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        project completed
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-sm-6">
                  <div className="binanceclone_significsec_card  align-items-start d-flex">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <span>50+</span>
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        On going projects
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-sm-6">
                  <div className="binanceclone_significsec_card  align-items-start d-flex">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <span>170+</span>
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        Satisfied clients
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-sm-6">
                  <div className="binanceclone_significsec_card  align-items-start d-flex">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <span>100+</span>
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">Team members</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-sm-6">
                  <div className="binanceclone_significsec_card  align-items-start d-flex">
                    <div className="containe_card_flex">
                      <div className="binanceclone_significsec_card_img mr-4">
                        <span>8</span>
                      </div>
                      <h3 className="binanceclone_h3_ik mb-2">
                        countries Served
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team__shape">
            <div className="shape shape--1">
              {" "}
              <img
                src={require("../../image/cryptolisting/t_shape1.webp")}
                className="bannerimg_boxes"
                alt="Crypto Listing Agency"
              />
            </div>
            <div className="shape shape--2">
              {" "}
              <img
                src={require("../../image/cryptolisting/t_shape2.webp")}
                className="bannerimg_boxes"
                alt="Crypto Listing Agency"
              />
            </div>
          </div>
        </section>
        <section className="binanceclone_whatissec_ik pos-rel ">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                {/* <div className="binanceclone_whatissec_image_ik">
                  <img
                    src={require("../../image/binancecloneik/whatisimg.webp")}
                    className=""
                    alt="Binance
Clone Script Development"
                  />
                  <img
                    src={require("../../image/binancecloneik/whatisimg_boxes.webp")}
                    className="whatisimg_boxes"
                    alt="Binance
Clone Script Development"
                  />
                </div> */}
                <div className="binanceclone_whatissec_content_ik d-flex flex-column">
                  <h2 className="mb-0 binanceclone_h2_ik">
                    Why Choose <br /> Beleaf Technologies
                    <br />
                    <span className="binanceclone_colorspan_ik">
                      {" "}
                      Crypto <br />
                      Listing Agency?{" "}
                    </span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center">
                <div className="binanceclone_whatissec_content_ik d-flex flex-column">
                  <p className="binanceclone_p_ik">
                    At Beleaf Technologies, our Crypto Listing service stands
                    out for its commitment to excellence. We combine advanced
                    technology with a deep understanding of market dynamics,
                    offering a personalized approach to each client. Our
                    streamlined processes and proven track record make us the
                    ideal partner for your token listing needs. And we are well
                    versed in the listing field for reliability and commitment.
                  </p>
                  <a href="https://wa.me/7904323274" className="">
                    <button className="binanceclone_button_ik">
                      Talk To Our Experts
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="shabe_left">
            <img
              src={require("../../image/cryptolisting/s_shape2.webp")}
              className="bannerimg_boxes"
              alt="Crypto Listing Agency"
            />
          </div>
        </section>
        <section className="binanceclone_Featuresec_ik pos-rel">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="binanceclone_Featuresec_title_ik ">
                  <h2 className="binanceclone_h2_ik text-center">
                    <span className="binanceclone_colorspan_ik">Takeaway</span>{" "}
                  </h2>
                  <p className="binanceclone_p_ik text-center">
                    visibility is the key for any crypto project to be
                    succeeded. Beleaf Technologies' Crypto Listing ensures your
                    crypto project not only gets noticed but thrives in the
                    competitive crypto world. Choose us for hassle free,
                    effective, and transparent token listing experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="shabe_right">
            <img
              src={require("../../image/cryptolisting/s_shape1.webp")}
              className="bannerimg_boxes"
              alt="Crypto Listing Agency"
            />
          </div>
        </section>
        <section id="about why new_faq bg_white CEX_faq">
          <section className="section bg_white CEX_faq" id="">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 align-items-center d-flex">
                  <div className="whybelaf faq">
                    <h2 className="">
                      Frequently asked <br />
                      Question
                    </h2>
                    <p></p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="comtent">
                    <div id="main">
                      <div className="container">
                        <div className="accordion" id="faq">
                          <div className="card">
                            <div className="card-header" id="faqhead1">
                              <a
                                href="#"
                                className="btn btn-header-link"
                                data-toggle="collapse"
                                data-target="#faq1"
                                aria-expanded="true"
                                aria-controls="faq1"
                              >
                                Why is Crypto Listing Important?
                              </a>
                            </div>

                            <div
                              id="faq1"
                              className="collapse show"
                              aria-labelledby="faqhead1"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Crypto listing enhances your project's
                                visibility, credibility, and market access,
                                attracting investors and users.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead2">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq2"
                                aria-expanded="true"
                                aria-controls="faq2"
                              >
                                How Long Does the Listing Process Take?
                              </a>
                            </div>

                            <div
                              id="faq2"
                              className="collapse"
                              aria-labelledby="faqhead2"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                The time frame varies but generally takes a few
                                weeks. Our team at Beleaf Technologies expedites
                                the process for timely results.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead3">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq3"
                                aria-expanded="true"
                                aria-controls="faq3"
                              >
                                What Information is Required for Listing?
                              </a>
                            </div>

                            <div
                              id="faq3"
                              className="collapse"
                              aria-labelledby="faqhead3"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Necessary details include project documentation,
                                tokenomics, and information about the team,
                                ensuring a comprehensive listing.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead4">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq4"
                                aria-expanded="true"
                                aria-controls="faq4"
                              >
                                Can You Guarantee a Coin's Success Post-Listing?
                              </a>
                            </div>

                            <div
                              id="faq4"
                              className="collapse"
                              aria-labelledby="faqhead4"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                While listing increases visibility, success
                                depends on various factors. We provide the
                                platform; the project's success is a
                                collaborative effort.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead5">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq5"
                                aria-expanded="true"
                                aria-controls="faq5"
                              >
                                Do You Offer Ongoing Support After Listing?
                              </a>
                            </div>

                            <div
                              id="faq5"
                              className="collapse"
                              aria-labelledby="faqhead5"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Yes, our support extends beyond the listing
                                process. We offer ongoing assistance to help
                                your project thrive in the crypto space.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </main>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Binace;
